
import { useMemo } from 'react'
import { pick } from 'ramda'

import { useFoodSuppliers } from 'app/dataProviders/cafeteria/compensation/foodSuppliers/hooks'
import PlainLink from 'app/common/ui-next/plain-link'

import styles from './AgreementMessage.scss'


type Props = {
  studentID: string
  supplierID: string
}

export const AgreementMessage = ({ studentID, supplierID }: Props) => {
  const { foodSuppliers } = useFoodSuppliers({ studentID })

  const { publicOfferURL, privacyConsentURL } = useMemo(() => {
    const supplier = foodSuppliers.find(({ ID }) => (ID === supplierID))
    if (supplier) {
      return pick(['publicOfferURL', 'privacyConsentURL'], supplier)
    }
    return { publicOfferURL: null, privacyConsentURL: null }
  }, [foodSuppliers, supplierID])

  const offerLink = <PlainLink to={publicOfferURL || ''} external>{'оферты'}</PlainLink>
  const privacyLink = <PlainLink to={privacyConsentURL || ''} external>{'персональных данных'}</PlainLink>

  if (publicOfferURL && privacyConsentURL) {
    return (
      <div className={styles.root}>
        {'Я принимаю условия '}
        {offerLink}
        {' и даю согласие на обработку '}
        {privacyLink}
        {' (мои и моего ребенка)'}
      </div>
    )
  }

  if (publicOfferURL) {
    return (
      <div className={styles.root}>
        {'Я принимаю условия '}
        {offerLink}
      </div>
    )
  }

  if (privacyConsentURL) {
    return (
      <div className={styles.root}>
        {'Я даю согласие на обработку '}
        {privacyLink}
        {' (мои и моего ребенка)'}
      </div>
    )
  }

  return null
}
